import { BaseModel } from './BaseModel';

export class Domain extends BaseModel {
    public id = -1;
    public name = '';

    // Admin only props
    public serversCount = -1;
    // Tag slugs a server's egg must carry to create subdomains on this domain
    // (empty = open to every server).
    public identifiers: string[] = [];
    public rootRecord?: string;

    getRouteName() {
        return 'domain';
    }

    getRouteID() {
        return this.id.toString();
    }
}
